// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/icon-fonts/icomoon.eot?bgw8si", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/icon-fonts/icomoon.ttf?bgw8si", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/icon-fonts/icomoon.woff?bgw8si", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/icon-fonts/icomoon.svg?bgw8si", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#icomoon" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'icomoon';
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

[class^="icon-"], [class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: middle;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-ban:before {
  content: "\\e900";
}
.icon-bank-card:before {
  content: "\\e901";
}
.icon-basket:before {
  content: "\\e902";
}
.icon-bell:before {
  content: "\\e903";
}
.icon-calendar-times:before {
  content: "\\e904";
}
.icon-chat-smile:before {
  content: "\\e905";
}
.icon-chat-tick:before {
  content: "\\e906";
}
.icon-chat:before {
  content: "\\e907";
}
.icon-circle-cloud:before {
  content: "\\e908";
}
.icon-circle-pause:before {
  content: "\\e909";
}
.icon-circle-tick:before {
  content: "\\e90a";
}
.icon-circle-times:before {
  content: "\\e90b";
}
.icon-clock:before {
  content: "\\e90c";
}
.icon-cloud-upload:before {
  content: "\\e90d";
}
.icon-database:before {
  content: "\\e90e";
}
.icon-disabled-eye:before {
  content: "\\e90f";
}
.icon-document-tick:before {
  content: "\\e910";
}
.icon-document:before {
  content: "\\e911";
}
.icon-dot-loading:before {
  content: "\\e912";
}
.icon-double-file:before {
  content: "\\e913";
}
.icon-double-right-arrow:before {
  content: "\\e914";
}
.icon-double-tick:before {
  content: "\\e915";
}
.icon-down-arrow:before {
  content: "\\e916";
}
.icon-left-arrow:before {
  content: "\\e916";
  rotate: 90deg;
  display: inline-block;
  font-size: 0.438rem;
}
.icon-download:before {
  content: "\\e917";
}
.icon-eye:before {
  content: "\\e918";
}
.icon-filled-heart:before {
  content: "\\e919";
}
.icon-filled-star:before {
  content: "\\e91a";
}
.icon-filled-warning:before {
  content: "\\e91b";
}
.icon-filter:before {
  content: "\\e91c";
}
.icon-folder-plus:before {
  content: "\\e91d";
}
.icon-folder:before {
  content: "\\e91e";
}
.icon-glasses:before {
  content: "\\e91f";
}
.icon-gmail:before {
  content: "\\e920";
}
.icon-heart:before {
  content: "\\e921";
}
.icon-hollow-question-mark:before {
  content: "\\e922";
}
.icon-home:before {
  content: "\\e923";
}
.icon-info:before {
  content: "\\e924";
}
.icon-instagram:before {
  content: "\\e925";
}
.icon-ir:before {
  content: "\\e926";
}
.icon-layers:before {
  content: "\\e927";
}
.icon-left-thumb:before {
  content: "\\e928";
}
.icon-like-thumb:before {
  content: "\\e929";
}
.icon-linkedin:before {
  content: "\\e92a";
}
.icon-list:before {
  content: "\\e92b";
}
.icon-location-marker:before {
  content: "\\e92c";
}
.icon-lock:before {
  content: "\\e92d";
}
.icon-logout:before {
  content: "\\e92e";
}
.icon-long-left-arrow:before {
  content: "\\e92f";
}
.icon-measure:before {
  content: "\\e930";
}
.icon-media:before {
  content: "\\e931";
}
.icon-menu-dots:before {
  content: "\\e932";
}
.icon-minus:before {
  content: "\\e933";
}
.icon-motion:before {
  content: "\\e934";
}
.icon-ninja:before {
  content: "\\e935";
}
.icon-pencil:before {
  content: "\\e936";
}
.icon-phone:before {
  content: "\\e937";
}
.icon-photo:before {
  content: "\\e938";
}
.icon-pin:before {
  content: "\\e939";
}
.icon-play:before {
  content: "\\e93a";
}
.icon-plus:before {
  content: "\\e93b";
}
.icon-pol-person:before {
  content: "\\e93c";
}
.icon-polygon-times:before {
  content: "\\e93d";
}
.icon-question-mark:before {
  content: "\\e93e";
}
.icon-refresh:before {
  content: "\\e93f";
}
.icon-sad-emoji:before {
  content: "\\e940";
}
.icon-search:before {
  content: "\\e941";
}
.icon-setting:before {
  content: "\\e942";
}
.icon-speaker:before {
  content: "\\e943";
}
.icon-square-down-arrow:before {
  content: "\\e944";
}
.icon-square-tick:before {
  content: "\\e945";
}
.icon-star-book:before {
  content: "\\e946";
}
.icon-statistics:before {
  content: "\\e947";
}
.icon-student:before {
  content: "\\e948";
}
.icon-text:before {
  content: "\\e949";
}
.icon-tick:before {
  content: "\\e94a";
}
.icon-ticket:before {
  content: "\\e94b";
}
.icon-times-print:before {
  content: "\\e94c";
}
.icon-times-speaker:before {
  content: "\\e94d";
}
.icon-times:before {
  content: "\\e94e";
}
.icon-trash:before {
  content: "\\e94f";
}
.icon-triangle-down-arrow:before {
  content: "\\e950";
}
.icon-upload:before {
  content: "\\e951";
}
.icon-verified-badge:before {
  content: "\\e952";
}
.icon-warning:before {
  content: "\\e953";
}
.icon-web-page:before {
  content: "\\e954";
}
.icon-working:before {
  content: "\\e955";
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/icons.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,6CAAmD;EACnD;;;yDAGqE;EACrE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+EAA+E;EAC/E,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;;EAEtB,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: 'icomoon';\n  src:  url('../fonts/icon-fonts/icomoon.eot?bgw8si');\n  src:  url('../fonts/icon-fonts/icomoon.eot?bgw8si#iefix') format('embedded-opentype'),\n    url('../fonts/icon-fonts/icomoon.ttf?bgw8si') format('truetype'),\n    url('../fonts/icon-fonts/icomoon.woff?bgw8si') format('woff'),\n    url('../fonts/icon-fonts/icomoon.svg?bgw8si#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-\"], [class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: middle;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-ban:before {\n  content: \"\\e900\";\n}\n.icon-bank-card:before {\n  content: \"\\e901\";\n}\n.icon-basket:before {\n  content: \"\\e902\";\n}\n.icon-bell:before {\n  content: \"\\e903\";\n}\n.icon-calendar-times:before {\n  content: \"\\e904\";\n}\n.icon-chat-smile:before {\n  content: \"\\e905\";\n}\n.icon-chat-tick:before {\n  content: \"\\e906\";\n}\n.icon-chat:before {\n  content: \"\\e907\";\n}\n.icon-circle-cloud:before {\n  content: \"\\e908\";\n}\n.icon-circle-pause:before {\n  content: \"\\e909\";\n}\n.icon-circle-tick:before {\n  content: \"\\e90a\";\n}\n.icon-circle-times:before {\n  content: \"\\e90b\";\n}\n.icon-clock:before {\n  content: \"\\e90c\";\n}\n.icon-cloud-upload:before {\n  content: \"\\e90d\";\n}\n.icon-database:before {\n  content: \"\\e90e\";\n}\n.icon-disabled-eye:before {\n  content: \"\\e90f\";\n}\n.icon-document-tick:before {\n  content: \"\\e910\";\n}\n.icon-document:before {\n  content: \"\\e911\";\n}\n.icon-dot-loading:before {\n  content: \"\\e912\";\n}\n.icon-double-file:before {\n  content: \"\\e913\";\n}\n.icon-double-right-arrow:before {\n  content: \"\\e914\";\n}\n.icon-double-tick:before {\n  content: \"\\e915\";\n}\n.icon-down-arrow:before {\n  content: \"\\e916\";\n}\n.icon-left-arrow:before {\n  content: \"\\e916\";\n  rotate: 90deg;\n  display: inline-block;\n  font-size: 0.438rem;\n}\n.icon-download:before {\n  content: \"\\e917\";\n}\n.icon-eye:before {\n  content: \"\\e918\";\n}\n.icon-filled-heart:before {\n  content: \"\\e919\";\n}\n.icon-filled-star:before {\n  content: \"\\e91a\";\n}\n.icon-filled-warning:before {\n  content: \"\\e91b\";\n}\n.icon-filter:before {\n  content: \"\\e91c\";\n}\n.icon-folder-plus:before {\n  content: \"\\e91d\";\n}\n.icon-folder:before {\n  content: \"\\e91e\";\n}\n.icon-glasses:before {\n  content: \"\\e91f\";\n}\n.icon-gmail:before {\n  content: \"\\e920\";\n}\n.icon-heart:before {\n  content: \"\\e921\";\n}\n.icon-hollow-question-mark:before {\n  content: \"\\e922\";\n}\n.icon-home:before {\n  content: \"\\e923\";\n}\n.icon-info:before {\n  content: \"\\e924\";\n}\n.icon-instagram:before {\n  content: \"\\e925\";\n}\n.icon-ir:before {\n  content: \"\\e926\";\n}\n.icon-layers:before {\n  content: \"\\e927\";\n}\n.icon-left-thumb:before {\n  content: \"\\e928\";\n}\n.icon-like-thumb:before {\n  content: \"\\e929\";\n}\n.icon-linkedin:before {\n  content: \"\\e92a\";\n}\n.icon-list:before {\n  content: \"\\e92b\";\n}\n.icon-location-marker:before {\n  content: \"\\e92c\";\n}\n.icon-lock:before {\n  content: \"\\e92d\";\n}\n.icon-logout:before {\n  content: \"\\e92e\";\n}\n.icon-long-left-arrow:before {\n  content: \"\\e92f\";\n}\n.icon-measure:before {\n  content: \"\\e930\";\n}\n.icon-media:before {\n  content: \"\\e931\";\n}\n.icon-menu-dots:before {\n  content: \"\\e932\";\n}\n.icon-minus:before {\n  content: \"\\e933\";\n}\n.icon-motion:before {\n  content: \"\\e934\";\n}\n.icon-ninja:before {\n  content: \"\\e935\";\n}\n.icon-pencil:before {\n  content: \"\\e936\";\n}\n.icon-phone:before {\n  content: \"\\e937\";\n}\n.icon-photo:before {\n  content: \"\\e938\";\n}\n.icon-pin:before {\n  content: \"\\e939\";\n}\n.icon-play:before {\n  content: \"\\e93a\";\n}\n.icon-plus:before {\n  content: \"\\e93b\";\n}\n.icon-pol-person:before {\n  content: \"\\e93c\";\n}\n.icon-polygon-times:before {\n  content: \"\\e93d\";\n}\n.icon-question-mark:before {\n  content: \"\\e93e\";\n}\n.icon-refresh:before {\n  content: \"\\e93f\";\n}\n.icon-sad-emoji:before {\n  content: \"\\e940\";\n}\n.icon-search:before {\n  content: \"\\e941\";\n}\n.icon-setting:before {\n  content: \"\\e942\";\n}\n.icon-speaker:before {\n  content: \"\\e943\";\n}\n.icon-square-down-arrow:before {\n  content: \"\\e944\";\n}\n.icon-square-tick:before {\n  content: \"\\e945\";\n}\n.icon-star-book:before {\n  content: \"\\e946\";\n}\n.icon-statistics:before {\n  content: \"\\e947\";\n}\n.icon-student:before {\n  content: \"\\e948\";\n}\n.icon-text:before {\n  content: \"\\e949\";\n}\n.icon-tick:before {\n  content: \"\\e94a\";\n}\n.icon-ticket:before {\n  content: \"\\e94b\";\n}\n.icon-times-print:before {\n  content: \"\\e94c\";\n}\n.icon-times-speaker:before {\n  content: \"\\e94d\";\n}\n.icon-times:before {\n  content: \"\\e94e\";\n}\n.icon-trash:before {\n  content: \"\\e94f\";\n}\n.icon-triangle-down-arrow:before {\n  content: \"\\e950\";\n}\n.icon-upload:before {\n  content: \"\\e951\";\n}\n.icon-verified-badge:before {\n  content: \"\\e952\";\n}\n.icon-warning:before {\n  content: \"\\e953\";\n}\n.icon-web-page:before {\n  content: \"\\e954\";\n}\n.icon-working:before {\n  content: \"\\e955\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
